//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const hsbCorrection = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function gethsbCorrection(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/hsbpointscorrection/get-hsbpointscorrection?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function gethsbCorrectionDetail(id) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(`${config.host}/cdr-panel/hsbpointscorrection/get-hsbpointscorrection/${id}`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function search(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/hsbpointscorrection/search?query=${encodeURIComponent(query)}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function hsbExport(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/hsbpointscorrection/export`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


  return {
    gethsbCorrection,
    gethsbCorrectionDetail,
    search,
    hsbExport,
   
  };
};

export default hsbCorrection;
